import request from '@/utils/request'


// 获取受理满意度
export function GetDegreeSatisfaction(params){
  return request({
    url: 'feedback/degree-satisfaction',
    method: 'get',
    params
  })
}
// 获取关注度TOP3
export function GetTOPAttention(params){
  return request({
    url: 'feedback/top3-attention',
    method: 'get',
    params
  })
}
// 获取服务反馈
export function GetFeedbackAmounts(params){
  return request({
    url: 'feedback/service-feedback-amounts',
    method: 'get',
    params
  })
}
// 获取前10条滚动数据
export function GetLiveData(params){
  return request({
    url: 'feedback/live-data',
    method: 'get',
    params
  })
}


// WEBPACK FOOTER //
// ./src/api/Home.js


// WEBPACK FOOTER //
// ./src/api/Home.js